// Force Reload 2
import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import { Elements } from '@stripe/react-stripe-js';
import './App.css';

import { isStaging } from './Helpers/helpers';
import { stripePromise } from './Helpers/payment_helpers';

// All Views
import Chat from './Pages/Chat/Chat';
import Collection from './Pages/Collection/Collection';
import Home from './Pages/Home/Home';
import MainContainer from './Containers/MainContainer/MainContainer';
import Result from './Pages/Result/Result';
import Contract from './Pages/Contract/Contract';
import Collaborations from './Pages/Collaborations/Collaborations';
import ConnectPaypal from './Pages/ConnectPaypal/ConnectPaypal';
import Consult from './Pages/Consult/Consult';
import Talent from './Pages/Talent/Talent';
import Blog from './Pages/Blog/Blog';
import Discover from './Pages/Discover/Discover';
import DiscoverOld from './Pages/Discover/DiscoverOld';
import List from './Pages/Lists/List';
import Guide from './Pages/Guide/Guide';
import SnapshopExtension from './Pages/Extensions/Snapshop';
import InstagramExtension from './Pages/Extensions/InstagramExtension';
import PartnerPortal from './Pages/Partners/PartnerPortal';
import Profile from './Pages/Profile/Profile';
import Links from './Pages/Links/Links';
import Latest from './Pages/Latest/Latest';
import Settings from './Pages/Settings/Settings';
import About from './Pages/Basic/About/About';
import AboutOld from './Pages/Basic/About/AboutOld';
import Apply from './Pages/Basic/Apply';
import Careers from './Pages/Basic/Careers';
import Contact from './Pages/Basic/Contact';
import BrandPartners from './Pages/Basic/BrandPartners';
import Directory from './Pages/Basic/Directory';
import Press from './Pages/Basic/Press';
import Terms from './Pages/Basic/Terms';
import FAQ from './Pages/Basic/FAQ';
import BrandFAQ from './Pages/Basic/BrandFAQ';
import Shop from './Pages/Shop/Shop';
import ShopDiscover from './Pages/Shop/ShopDiscover';
import Curators from './Pages/Shop/Curators';
import Product from './Pages/Shop/Product';
import Taste from './Pages/Shop/Taste';
import Report from './Pages/Report/Report';
import Snapshop from './Pages/Explainers/Snapshop';
import Subscriptions from './Pages/Subscriptions/Subscriptions';
import LandingLogin from './Pages/Landing/LandingLogin';
import OAuthLanding from './Components/OAuth/OAuthLanding';
import BrandApply from './Pages/Landing/BrandApply';
import MobileLanding from './Pages/Landing/MobileLanding';
import CollectionEmbed from './Pages/Embed/CollectionEmbed';
import SocialAuth from './Components/Redirects/SocialAuth';
import Logout from './Components/Redirects/Logout';
import Commissions from './Pages/Commissions/Commissions';
import Requests from './Pages/Requests/Requests';
import RequestsPortal from './Pages/Requests/RequestsPortal';
import ReferredCreator from './Pages/Referral/ReferredCreator';
import ReferNewCreator from './Pages/Referral/ReferNewCreator';
import CreatorApplication from './Pages/Application/CreatorApplication';
import Codes from './Pages/Codes/Codes';
import Mentions from './Pages/Mentions/Mentions';
import Catalog from './Pages/Catalog/Catalog';
import Lookbooks from './Pages/Lookbooks/Lookbooks';
import Opportunity from './Pages/Opportunity/Opportunity';
import LookbookOrderDetails from './Pages/Lookbooks/LookbookOrderDetails';
import RootRedirect from './Pages/Redirects/RootRedirect';
import NYFW from './Pages/Landing/NYFW';
import EarningsPortal from './Components/Payouts/EarningsPortal';
import BrandSetupRedirect from './Pages/Landing/BrandSetupRedirect';

class App extends Component {
  render() {
    const PublicRouteRender = ({ component: Component, componentProps = {}, theme = 'light', ...rest }) => (
      <Route
        {...rest}
        render={props => (
          <MainContainer theme={theme}>
            <Component {...props} {...componentProps} />
          </MainContainer>
        )}
      />
    );

    const StripeWrapper = props => {
      return <Elements stripe={stripePromise}>{props.children}</Elements>;
    };

    return (
      <StripeWrapper>
        <Router>
          <LastLocationProvider>
            <Switch>
              <PublicRouteRender exact path='/' component={RootRedirect} />
              <PublicRouteRender exact path='/home' component={Home} />
              <PublicRouteRender exact path='/home/creators/:step?' component={Home} componentProps={{ isCreatorLandingPage: true }} />
              <PublicRouteRender exact path='/home/brands/:step?' component={Home} componentProps={{ isBrandsLandingPage: true }} />
              <PublicRouteRender exact path='/home/shoppers/:step?' component={Home} componentProps={{ isShopLandingPage: true }} />
              <PublicRouteRender exact path='/nyfw' component={NYFW} />
              <PublicRouteRender exact path='/mobile/redirect' component={MobileLanding} />
              <PublicRouteRender exact path='/chat' component={Chat} />
              <PublicRouteRender exact path='/shop/how-it-works' component={props => <div>Coming Soon</div>} />
              <PublicRouteRender exact path='/shop/my/circles' component={Curators} componentProps={{ isDiscover: false }} />
              <PublicRouteRender exact path='/shop/my/circles/:id' component={Curators} componentProps={{ isDiscover: false }} />
              <PublicRouteRender exact path='/shop/my/taste' component={Taste} />
              <PublicRouteRender exact path='/shop/circles/' component={Curators} componentProps={{ isDiscover: true }} />
              <PublicRouteRender exact path='/shop/circles/:id' component={Curators} componentProps={{ isDiscover: true }} />
              <PublicRouteRender exact path='/shop/product/:id' component={Product} />
              <PublicRouteRender exact path='/shop/collections/:id' component={Collection} componentProps={{ isShop: true }} />
              <PublicRouteRender exact path='/shop' component={Shop} />
              <PublicRouteRender exact path='/shop/group' component={Shop} />
              <PublicRouteRender exact path='/shop/discover/:tab' component={ShopDiscover} />
              <PublicRouteRender exact path='/shop/:username' component={Shop} />
              <PublicRouteRender exact path='/shop/:username/:tab' component={Shop} />
              <PublicRouteRender exact path='/logout' component={Logout} />
              <PublicRouteRender exact path='/welcome' component={LandingLogin} />
              <PublicRouteRender exact path='/oauth' component={OAuthLanding} theme='dark' />
              <PublicRouteRender exact path='/invite/:username' component={ReferNewCreator} />
              <PublicRouteRender exact path='/join/:username' component={ReferredCreator} />
              <PublicRouteRender exact path='/promote/:username' component={ReferredCreator} />
              <PublicRouteRender exact path='/apply/creator' component={CreatorApplication} />
              <PublicRouteRender exact path='/shops/public/:username/:tab' component={Profile} />
              <PublicRouteRender exact path='/shops/public/:username' component={Profile} />
              <PublicRouteRender exact path='/shops/:username/:tab' component={Profile} />
              <PublicRouteRender exact path='/shops/:username' component={Profile} />
              <PublicRouteRender exact path='/products/:stub' component={Product} />
              <PublicRouteRender exact path='/s/:username' component={Profile} />
              <PublicRouteRender exact path='/s/public/:username' component={Profile} />
              <PublicRouteRender exact path='/shop-guide' component={Guide} />
              <PublicRouteRender exact path='/shop-guide/:howto' component={Guide} />
              <PublicRouteRender exact path='/links/:tab?' component={Links} />
              <PublicRouteRender exact path='/discover' component={Discover} />
              <PublicRouteRender exact path='/discover/:id' component={List} />
              <PublicRouteRender exact path='/new/discover' component={Discover} />
              {/* Since we used this for testing, keep these - remove after October 2023 */}
              <PublicRouteRender exact path='/new/discover/:id' component={List} />
              {/* Since we used this for testing, keep these - remove after October 2023 */}
              <PublicRouteRender exact path='/list/:id' component={List} componentProps={{ isBrandList: true }} />
              <PublicRouteRender exact path='/v1/discover' component={DiscoverOld} />
              <PublicRouteRender exact path='/payouts' component={EarningsPortal} />
              <PublicRouteRender exact path='/settings' component={Settings} />
              <PublicRouteRender exact path='/mentions' component={Mentions} />
              <PublicRouteRender exact path='/catalog/:tab?' component={Catalog} />
              <PublicRouteRender exact path='/report' component={Report} />
              <PublicRouteRender exact path='/commissions' component={Commissions} />
              <PublicRouteRender exact path='/partners/:tab?' component={PartnerPortal} />
              <PublicRouteRender exact path='/v0/gifting' component={Requests} />
              <PublicRouteRender exact path='/gifting/:tab?' component={RequestsPortal} /> {/* Deprecated for /requests, remove after June 2024 */}
              <PublicRouteRender exact path='/requests/:tab?' component={RequestsPortal} /> {/* Deprecated for below, remove after June 2024 */}
              <PublicRouteRender exact path='/requests' component={RequestsPortal} componentProps={{ tab: 'requests' }} />
              <PublicRouteRender exact path='/lookbooks' component={RequestsPortal} componentProps={{ tab: 'lookbooks' }} />
              <PublicRouteRender exact path='/opportunities' component={RequestsPortal} componentProps={{ tab: 'opportunities' }} />
              <PublicRouteRender exact path='/recommendations' component={RequestsPortal} componentProps={{ tab: 'recommendations' }} />
              <PublicRouteRender exact path='/opportunity/:id/:tab?' component={Opportunity} />
              <PublicRouteRender exact path='/lookbooks/:id' component={Lookbooks} />
              <PublicRouteRender exact path='/lookbooks/:id/analytics' component={Lookbooks} />
              <PublicRouteRender exact path='/lookbooks/order/:LookbookOrder_id' component={LookbookOrderDetails} />
              <PublicRouteRender exact path='/codes' component={Codes} />
              <PublicRouteRender exact path='/collections/:id' component={Collection} />
              <PublicRouteRender exact path='/collections/public/:id' component={Collection} />
              <PublicRouteRender exact path='/collections/quick/:id' component={Collection} />
              <PublicRouteRender exact path='/collections/embed/:id' component={CollectionEmbed} />
              <PublicRouteRender exact path='/collaboration/:id/:type?' component={Contract} />
              <PublicRouteRender exact path='/collaborations/:tab?' component={Collaborations} />
              <PublicRouteRender exact path='/connect/paypal' component={ConnectPaypal} />
              <PublicRouteRender exact path='/consults/results/:stub' component={Result} />
              <PublicRouteRender exact path='/consults/:id' component={Consult} />
              <PublicRouteRender exact path='/consults/:id/:stub' component={Consult} />
              <PublicRouteRender exact path='/public/consults/results/:stub' component={Result} />
              <PublicRouteRender exact path='/public/consults/:id' component={Consult} />
              <PublicRouteRender exact path='/public/consults/:id/:stub' component={Consult} />
              <PublicRouteRender path='/latest' component={Latest} />
              <PublicRouteRender path='/dashboard' component={Talent} />
              <PublicRouteRender path='/talent' component={Talent} />
              <PublicRouteRender exact path='/subscriptions/:tab?' component={Subscriptions} />
              <PublicRouteRender exact path='/blog' component={Blog} />
              <PublicRouteRender exact path='/blog/:tab_title' component={Blog} />
              <PublicRouteRender exact path='/blog/:tab_title/:post_url_stub' component={Blog} />
              <PublicRouteRender path='/about' component={isStaging() ? About : AboutOld} />
              <PublicRouteRender path='/team' component={isStaging() ? About : AboutOld} />
              <PublicRouteRender path='/apply' component={Apply} />
              <PublicRouteRender path='/careers' component={Careers} />
              <PublicRouteRender path='/contact' component={Contact} />
              <PublicRouteRender path='/shops' component={Directory} />
              <PublicRouteRender path='/directory' component={Directory} />
              <PublicRouteRender path='/press' component={Press} />
              <PublicRouteRender path='/terms' component={Terms} />
              <PublicRouteRender path='/snapshop' component={Snapshop} />
              <PublicRouteRender path='/forbrands' component={BrandApply} />
              <PublicRouteRender path='/brand-faq' component={BrandFAQ} />
              <PublicRouteRender path='/brand-partners' component={BrandPartners} />
              <PublicRouteRender exact path='/shopify-integration' component={BrandSetupRedirect} />
              <PublicRouteRender exact path='/brand-setup' component={BrandSetupRedirect} />
              <PublicRouteRender exact path='/social_auth/:type' component={SocialAuth} />
              {/* extensions */}
              <PublicRouteRender path='/quick-links-extension' component={SnapshopExtension} />
              <PublicRouteRender path='/instagram-extension' component={InstagramExtension} />
              {/* For Clean Social URLs */}
              <PublicRouteRender exact path='/c/:id' component={Collection} />
              <PublicRouteRender exact path='/public/:username/:tab' component={Profile} />
              <PublicRouteRender exact path='/public/:username' component={Profile} />
              <PublicRouteRender exact path='/:username/:tab?' component={Profile} />
            </Switch>
          </LastLocationProvider>
        </Router>
      </StripeWrapper>
    );
  }
}

export default App;
